import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=1ecf9526"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports